import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './style/style.scss';

import VueScrollmagic from 'vue-scrollmagic';
Vue.use(VueScrollmagic);

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
